import { useTranslation } from 'react-i18next';
import { Box, Button, Modal, Text } from '@sendible/design-system/src';

type DiscardChangesModalProps = {
  onDiscard: () => void;
  onCancel: () => void;
};

export const DiscardChangesModal = ({ onDiscard, onCancel }: DiscardChangesModalProps) => {
  const { t } = useTranslation('reports');

  return (
    <Modal
      close={onCancel}
      customClass="global-modal"
      headingTitle={t('new_reports_discard_modal_heading') as string}
      testId="discard-changes-modal"
      variation="medium"
      ariaCloseLabel={t('new_reports_discard_modal_close_label') as string}
      footerContent={
        <Box
          fullWidth
          contentJustify="flex-end"
          horizontalGap="s8"
        >
          <Button
            onClick={onCancel}
            label={t('new_reports_cancel') as string}
            size={16}
            variation="outline"
            autoFocus
          />
          <Button
            appearance="primary"
            onClick={onDiscard}
            label={t('new_reports_discard_modal_discard') as string}
            size={16}
            variation="fill"
          />
        </Box>
      }
    >
      <Text>{t('new_reports_discard_modal_body')}</Text>
    </Modal>
  );
};
